import * as React from "react";

import "./amount-breakdown.scss";

import {cs}           from "@Common/react/chain-services";
import {cascadeSum}   from "@Common/utils/cascade";

import {BreakdownTable} from "./breakdown-table/breakdown-table";

export const AmountBreakdown = ({amounts, rdfDescription}:{
    amounts : Array<{label: string, value: number}>,
    rdfDescription?: string,
}) => cs(
    () => (
        <div className="amount-breakdown amount-breakdown-6e1">
            <div className="title" xd-qa-type="label" xd-qa-name="AMOUNT DUE">
                AMOUNT DUE
            </div>

            {BreakdownTable({
                sections: [
                    amounts?.map((amount) => ({...amount, value: amount.value})) || [],
                    [
                        {
                            label: "Total",
                            value: cascadeSum(amounts, "[*].value"),
                        },
                    ],
                ],
                rdfDescription,
            })}
        </div>
    ),
);

